import commonResource from '../abstract.resource';

import {readNextReservationSlot} from '../serializers/next-reservation-slot.serializer';

const mod = angular.module('app.common.resources.nextTimes', [commonResource])

.factory('NextTimesResource', function (AbstractResource) {
  class NextTimesResource extends AbstractResource {
    constructor() {
      super('reservationslots', NextTimesResource.fromBackend, false);
    }

    /**
     * Filter next times from the backend with the given arguments
     * @param {{location: ?number, coordinates: ?Coordinates, service: ?number}} filters
     *   Filters given to the request. Each is optional. If location is given, it will override coordinates.
     * @param {number} amount Amount of times to retrieve from the backend.
     * @returns {Promise.<ResourceCollection>} Request promise that will resolve with a ResourceCollection
     *   of the returned slots.
     */
    filterTimes(filters, amount) {
      const {location, city, coordinates, service, person} = filters;
      let params = {};

      if (location != null) {
        params.location = location;
      }
      else if (city != null) {
        params.city = city;
      }
      else if (coordinates != null) {
        params.lat = coordinates.lat;
        params.lon = coordinates.lon;
      }

      if (service != null) {
        params.service = service;
      }

      if (person != null) {
        params.person = person;
      }

      params.n = amount;

      return this.getMany(params);
    }

    /**
     * Parse a reservation slot retrieved from the backend.
     * @param {Object} o
     * @returns {ReservationSlot}
     */
    static fromBackend(o) {
      return readNextReservationSlot(o).makeImmutable();
    }
  }

  return new NextTimesResource();
});

export default mod.name;
